import { useContext } from 'react';
import FeatureToggleProvider from '@guestyci/feature-toggle-fe/FeatureToggleProvider';

import { env } from 'api';
import { WebsiteSettingsContext } from 'context/WebsiteSettingsContext';

const FeatureToggleContext = ({ children }) => {
  const { accountData: { accountId } = {} } = useContext(WebsiteSettingsContext);

  return (
    <FeatureToggleProvider accountId={accountId} env={env}>
      {children}
    </FeatureToggleProvider>
  );
};

export default FeatureToggleContext;
